import { render, staticRenderFns } from "./WServicePicker.vue?vue&type=template&id=db2c6572&scoped=true&"
import script from "./WServicePicker.vue?vue&type=script&lang=js&"
export * from "./WServicePicker.vue?vue&type=script&lang=js&"
import style0 from "./WServicePicker.vue?vue&type=style&index=0&id=db2c6572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c6572",
  null
  
)

export default component.exports